import { useQuery } from 'react-query';
import { fetchWrapper } from 'utils/fetchWrapper';
import toastr from 'react-hot-toast';
import { INFINITE_CACHE_AND_STALE_TIME } from 'constants/index';
import { generateURL } from 'utilities/hooks/urlGeneration';
import { SPARK_RESOURCE_TYPES } from 'constants/common';

import type {
  StripeAccountStatusTypeResponse,
  StripeAccountStatusType,
} from 'types/entityTypes/StripeAccountStatusType';

const getStripeAccountStatusTypes = () => {
  const url = generateURL(SPARK_RESOURCE_TYPES.STRIPE_ACCOUNT_STATUS_TYPE);
  return fetchWrapper<StripeAccountStatusTypeResponse>({
    url: url,
    method: 'GET',
  });
};

export function useStripeAccountStatusTypes() {
  const response = useQuery(
    SPARK_RESOURCE_TYPES.STRIPE_ACCOUNT_STATUS_TYPE,
    getStripeAccountStatusTypes,
    {
      onError: (error) => {
        if (error instanceof Error) {
          toastr.error(
            `failed to Fetch stripe account status: ${error.message}`
          );
        }
      },
      ...INFINITE_CACHE_AND_STALE_TIME,
    }
  );

  const { data: stripeAccountStatusTypes } = response.data || {};

  const stripeAccountStatusTypesIdMap = stripeAccountStatusTypes?.reduce<
    Record<string, StripeAccountStatusType>
  >((acc, curr) => {
    return { ...acc, [curr.id]: curr };
  }, {});

  return {
    stripeAccountStatusTypes,
    stripeAccountStatusTypesIdMap,
    ...response,
  };
}
